query GetYearOverviewStats($fiscalYears: [Int!]!) {
    quotaYearOverview(fiscalYears: $fiscalYears) {
        fiscalYear
        yearValue {
            amount
        }
        months {
            value {
                amount
            }
            identifier
        }
    }
}
